<template>
	<section class="main-content intro-content">
		<div class="row">
			<slot>
				<div style="width: 100%">
					<div class="columns column12 align-center">
						<div class="header-flex-wrapper">
							<h1>{{ title || header }}</h1>
							<h2 v-if="subtitle" class="small">{{ subtitle }}</h2>
						</div>
						<slot v-if="rightContent" name="extra-heading" />
					</div>
					<div v-if="rightContent" class="flex-row">
						<div class="columns column6">
							<div v-parse-links v-html="content" />
						</div>
						<div class="columns column6">
							<div v-parse-links v-html="rightContent" />
							<slot name="extra-content" />
						</div>
					</div>
					<div v-else style="width: 100%">
						<div class="columns column12 align-center">
							<slot name="extra-heading" />
							<div v-parse-links v-html="content" />
							<slot name="extra-content" />
						</div>
					</div>
				</div>
			</slot>
		</div>
	</section>
	<section v-if="extraContent" class="main-content background-secondary extra-content">
		<div class="row flex-row justify-center">
			<div class="columns column7">
				<div v-parse-links v-html="extraContent" />
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
	rightContent: { type: String, default: '' },
	extraContent: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.flex-row {
	display: flex;
	flex-flow: row wrap;
	place-content: flex-start space-between;

	&.justify-center {
		justify-content: center;
	}
}

.extra-content {
	color: #7b7b7b;
	padding: 75px 0;
}

.intro-content .row {
	max-width: 1200px;
}

.index .intro-content .row {
	max-width: 100%;
}

@media (max-width: 880px) {
	.intro {
		padding: 50px 0;
	}
}
</style>
